<template>
  <v-card class="fluid-column ma-5">


    <div>
      <v-card-item>
        <v-card-title class="text-headline-small">Storico dati trasferiti</v-card-title>
        <v-card-subtitle class="">I dati trasferiti dal dispositivo corrente
          <v-icon class="mb-1" @click="showInfo = !showInfo" color="grey">mdi-information</v-icon>
        </v-card-subtitle>
      </v-card-item>

      <v-card-text>
        <v-slide-y-transition>
          <div v-if="showInfo">
            La tabella contiene il registro dei dati inviati dal dispositivo.<br>
            I record salvati rappresentano:<br>
            <ul class="pl-5">
              <li>segnalazioni</li>
              <li>media</li>
              <li>giornate diario</li>
            </ul>
            <strong>
              Potrebbero essere già stati eliminati dopo il trasferimento al server,<br>
              è comunque possibile andare alla posizione in cui è stato raccolto il dato.
            </strong>

          </div>
        </v-slide-y-transition>
        <v-data-table :headers="headers" :items="historyStore.userHistory" item-key="uuid"
            :items-per-page="itemsPerPage" :items-per-page-options="itemsPerPageOptions"
            items-per-page-text="Elementi per pagina" no-data-text="-">

<!-- 

            <template v-slot="headers">
            <tr>
              <th>
                <v-icon class="ma-2">mdi-map-search</v-icon>
              </th>
              <th>Oggetto</th>
              <th>q250</th>
            </tr>
          </template> -->

          <template v-slot:item.entry="{ item }">
            <p class="text-body-large text-truncate">
              {{ new Date(item.timestamp || 0).toLocaleString() }}
            </p>
            <p class="text-title-small">{{ item.label }}</p>
            <p class="text-grey-darken-1 pl-4">
              tipo: {{ item?.type }}<br>
              {{ sentOn(item) }}
            </p>
          </template>
          <template v-slot:item.q250="{ item }">
            {{ squareID(item?.coords) }}
          </template>
          <template v-slot:item.vai="{ item }">
            <v-btn v-if="item.coords" color="primary" size="" :to="{
              name: 'map',
              query: {
                coord0: item.coords[0],
                coord1: item.coords[1],
                epsg: 4326,
                uuid: item?.uuid,
              }
            }">
              <v-icon class="ma-2">mdi-map-search</v-icon>
            </v-btn>
          </template>
        </v-data-table>

      </v-card-text>
    </div>


  </v-card>
</template>

<script setup>

import { onMounted, ref, computed } from "vue";

import { useHistoryStore } from "@/store/history"

import { EPSG4326_to_UTMPNGP250 } from '@/components/map/utils/UTMPNGP250'

// const projExtent = getProjection('EPSG:32632')?.getExtent();


const historyStore = useHistoryStore()

const showInfo = ref(false)
const headers = [
  {
    title: '',
    key: 'vai',
    sortable: false
  },
  {
    title: 'Oggetto',
    key: 'entry',
    sortable: false,
  },
  // {
  //   title: 'Quando',
  //   key: 'timestamp',
  //   value: item => new Date(item.timestamp).toLocaleString(),
  //   sortable: false,
  // },
  // {
  //   title: 'Cosa',
  //   key: 'label',
  //   sortable: false
  // },
  // {
  //   title: 'Q250',
  //   key: 'q250',
  //   value: (item) => {
  //     // const lonlat = [lon, lat]
  //     if(!item.coords) return "-"
  //     return EPSG4326_to_UTMPNGP250(item.coords)?.squareID
  //   },
  //   sortable: false
  // },
  {
    title: 'q250',
    key: 'q250',
    sortable: false
  },
]


const squareID = (coords) => {
  let id = EPSG4326_to_UTMPNGP250(coords)?.squareID
  if (!id) id = ""
  if (id === -1) id = ""
  return id
}


const sentOn = (item) => {
  if (!item?.created) return ""
  return "inviato: " + new Date(item.created).toLocaleString()
}


const itemsPerPageOptions = ref([10, 25, 50, 100])
const itemsPerPage = ref(10)

onMounted(() => {



});


</script>

<style scoped>
.pulsating {
  animation-name: color;
  animation-duration: 1s;
  animation-iteration-count: infinite;
  animation-direction: alternate-reverse;
  animation-timing-function: linear;
}


@keyframes color {
  from {
    color: orange;
  }

  to {
    color: white;
    text-shadow: 0 0 10px #fff, 0 0 20px #fff, 0 0 30px orange;
  }
}

.no-mouse {
  pointer-events: none;
}
</style>
